import { render } from "./Data.vue?vue&type=template&id=dbc63d28"
import script from "./Data.vue?vue&type=script&lang=js"
export * from "./Data.vue?vue&type=script&lang=js"
script.render = render

export default script